export default "__VITE_ASSET__DI9c2B6I__"